import { NextPage } from 'next'
import Head from 'next/head'
import PageHeader from '@components/PageHeader'
import { Layout, ImagesGrid, TextBlock } from '@components/work'
import Button from '@components/Button'

const WillischPage: NextPage = () => (
  <>
    <Head>
      <title>Work - Willisch</title>
    </Head>

    <PageHeader
      title={[['Willisch']]}
      subtitle={[['Ice cream', 'delivered to', 'your door']]}
    />

    <Layout>
      <ImagesGrid
        images={[
          { src: '/images/work/willisch/01.jpg', alt: '' },
          { src: '/images/work/willisch/02.jpg', alt: '' },
        ]}
      />

      <TextBlock>
        <p>
          Ice Cream Delivery? It's possible from now on! Thanks to the
          e-commerce and corporate platform we have created, designed for the
          Willisch company, you can easily order natural ice cream with delivery
          to a designated place.
        </p>

        <p>
          The website allows franchisees to manage their own ice cream parlors,
          and the user, using the geolocation function, can check where the
          nearest Willisch ice cream shop is. The unusual design of the website
          and the implemented content management system make this online store
          an exceptionally successful and unique e-commerce project.
        </p>

        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://willisch.pl/"
          className="d-inline-block"
        >
          <Button theme="red-outline" text="Check it out" />
        </a>
      </TextBlock>

      <ImagesGrid
        images={[
          { src: '/images/work/willisch/03.jpg', alt: '' },
          { src: '/images/work/willisch/04.jpg', alt: '' },
        ]}
      />
    </Layout>
  </>
)

export default WillischPage
